import declaration from "./declaration.store";
import feeStatement from "./fee-statement.store";
import freeSale from "./free-sale.store";
import hazAquatic from "./haz-aquatic.store";
import hazDiscussAquatic from "./haz-discuss-aquatic.store";
import hazDiscussMainSubStance from "./haz-discuss-main-sub-stance.store";
import hazDiscussPictogram from "./haz-discuss-pictogram.store";
import hazDiscussUseRate from "./haz-discuss-use-rate.store";
import hazDiscuss from "./haz-discuss.store";
import hazDistributor from "./haz-distributor.store";
import hazImportCompany from "./haz-import-company.store";
import hazImportProduct from "./haz-import-product.store";
import hazLicenseCountry from "./haz-license-country.store";
import hazLicenseDetail from "./haz-license-detail.store";
import hazLicenseStorageLocation from "./haz-license-storage-location.store";
import hazLicense from "./haz-license.store";
import hazMainSubStance from "./haz-main-sub-stance.store";
import hazMgtStorageLocationStore from "./haz-mgt-storage-location-store.store";
import hazMgtStorageLocation from "./haz-mgt-storage-location.store";
import hazMgt from "./haz-mgt.store";
import hazPackage from "./haz-package.store";
import hazPictogram from "./haz-pictogram.store";
import hazProduct from "./haz-product.store";
import hazTest from "./haz-test.store";
import hazUseRate from "./haz-use-rate.store";
import haz from "./haz.store";
import hcProductQty from "./hc-product-qty.store";
import hcProduct from "./hc-product.store";
import hc from "./hc.store";
import informProductQty from "./inform-product-qty.store";
import informProduct from "./inform-product.store";
import inform from "./inform.store";
import inspectionOfficer from "./inspection-officer.store";
import inspectionProduct from "./inspection-product.store";
import inspection from "./inspection.store";
import manufactureSampleProduct from "./manufacture-sample-product.store";
import manufactureSample from "./manufacture-sample.store";
import releaseOfficer from "./release-officer.store";
import releaseProduct from "./release-product.store";
import release from "./release.store";
import openInspection from "./open-inspection.store";
import sampling from "./sampling.store";
import samplingDistributor from "./sampling-distributor.store";
import sequestrate from "./sequestrate.store";
import cancelSequestrate from "./cancel-sequestrate.store";
import cancelSequestrateProduct from "./cancel-sequestrate-product.store";
import request from "./request.store";
import statusHistory from "./status-history.store";
import stockCard from "./stock-card.store";
import storageLocationExpert from "./storage-location-expert.store";
import storageLocationProductType from "./storage-location-product-type.store";
import storageLocationSubItem from "./storage-location-sub-item.store";
import storageLocationSub from "./storage-location-sub.store";
import storageLocationType from "./storage-location-type.store";
import storageLocation from "./storage-location.store";
import transferDeclaration from "./transfer-declaration.store";
import transferDeclarationProduct from "./transfer-declaration-product.store";
import transferDeclarationProductQty from "./transfer-declaration-product-qty.store";
import userAuthorize from "./user-authorize.store";
import userAuthorizeRole from "./user-authorize-role.store";
import userBank from "./user-bank.store";
import userCa from "./user-ca.store";
import userCommittee from "./user-committee.store";
import userObjective from "./user-objective.store";
import userOperatorType from "./user-operator-type.store";
import userRequest from "./user-request.store";
import toWhom from "./to-whom.store";
import docDuration from "./doc-duration.store";
import sendSampling from "./send-sampling.store";
import sendSamplingProduct from "./send-sampling-product.store";
import samplingAnalysis from "./sampling-analysis.store";
import samplingAnalysisProduct from "./sampling-analysis-product.store";
import entityLog from "./entity-log.store";

export default {
    userOperatorType,
    userObjective,
    userRequest,
    statusHistory,
    request,
    haz,
    hazProduct,
    hazMainSubStance,
    hazPictogram,
    hazAquatic,
    hazPackage,
    hazTest,
    hazUseRate,
    hazDistributor,
    hazImportCompany,
    hazImportProduct,
    storageLocation,
    storageLocationSub,
    storageLocationExpert,
    storageLocationType,
    storageLocationProductType,
    userBank,
    userCommittee,
    userAuthorize,
    userAuthorizeRole,
    userCa,
    hazLicense,
    hazLicenseDetail,
    hazLicenseStorageLocation,
    hazLicenseCountry,
    inform,
    informProduct,
    informProductQty,
    feeStatement,
    hazDiscuss,
    hazDiscussMainSubStance,
    hazDiscussAquatic,
    hazDiscussPictogram,
    hazDiscussUseRate,
    manufactureSample,
    manufactureSampleProduct,
    inspection,
    inspectionOfficer,
    inspectionProduct,
    release,
    openInspection,
    sampling,
    samplingDistributor,
    sequestrate,
    cancelSequestrate,
    cancelSequestrateProduct,
    releaseOfficer,
    releaseProduct,
    freeSale,
    stockCard,
    hazMgt,
    hazMgtStorageLocation,
    hazMgtStorageLocationStore,
    storageLocationSubItem,
    hc,
    hcProduct,
    hcProductQty,
    declaration,
    transferDeclaration,
    transferDeclarationProduct,
    transferDeclarationProductQty,
    toWhom,
    docDuration,
    sendSampling,
    sendSamplingProduct,
    samplingAnalysis,
    samplingAnalysisProduct,
    entityLog
};
